var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWposition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.72211C0 5.27549 0 3.82647 0 2.37985H6.10796V0H14.3103V2.39184H20.3942C20.3942 3.80248 20.4134 5.18912 20.3822 6.57577C20.3727 6.998 20.2791 7.43942 20.1327 7.83766C19.4562 9.68493 17.8489 10.7837 15.8816 10.7885C14.9196 10.7885 13.9552 10.7885 12.9932 10.7885C12.9284 10.7885 12.8661 10.7837 12.7797 10.7789V9.60336H7.60256V10.7717C6.40544 10.7717 5.22511 10.8485 4.05918 10.7549C2.2551 10.6086 0.993203 9.62735 0.307077 7.94802C0.15114 7.56178 0.10076 7.13235 0 6.72211ZM7.30268 1.19232V2.36785H13.094V1.19232H7.30268Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 15.2771 0 12.5542 0 9.8313C0.146341 9.99443 0.285486 10.1648 0.441423 10.3183C1.57617 11.4315 2.94362 11.9808 4.53179 11.9832C5.48181 11.9832 6.43183 11.9832 7.38185 11.9832H7.61695V13.1636H12.8013V11.9832H13.0316C13.9888 11.9832 14.9436 11.988 15.9008 11.9832C17.3882 11.976 18.6957 11.489 19.7945 10.4742C20.0008 10.2847 20.2095 10.0976 20.3918 9.93206V18C20.2959 18 20.2095 18 20.1256 18C13.4178 18 6.71012 18 0.00239904 18H0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80859 11.9712V10.8029H11.5795V11.9712H8.80859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWposition);
export default __webpack_public_path__ + "static/media/wposition.ab43b9148e54e496e04f7776bcef4d12.svg";
export { ForwardRef as ReactComponent };